<template>
    <alert :icon="icons.locked" large class="flex-grow-1" :content="text ? text : $t('action.login_to_see_more')"
           :tile="tile"
		   :xs-tile="xsTile"
		   :sm-tile="smTile"
           :no-spacing="noSpacing" :shadow="!flat" :vertical="vertical">

        <btn :to="loginPath" :color="color" class="mt-16 w-full min-w-200" :class="{'sm:mt-0 sm:ml-16 sm:w-auto': !vertical}" nofollow>
            <span>{{ $t('action.login') }}</span>
        </btn>

    </alert>
</template>

<script>
import {mdiLockOutline} from '@mdi/js';

export default {
    name: 'LoginToSeeMore',

    props: {
        text: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: 'primary'
        },

        // The query params to add to the login path
        query: {
            type: Object,
            default: () => {
            }
        },

        tile: {
            type: Boolean,
            default: false
        },

		xsTile: {
			type: Boolean,
			default: false
		},

		smTile: {
			type: Boolean,
			default: false
		},

        flat: {
            type: Boolean,
            default: false
        },

        // Whether to vertically align the content even on desktop devices
        vertical: {
            type: Boolean,
            default: false
        },

        noSpacing: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            icons: {
                locked: mdiLockOutline,
            }
        }
    },

    computed: {
        loginPath() {
            const queryParams = {redirect: this.$route.path, ...this.query};

            return {path: this.$web('auth.login'), query: queryParams}
        }
    }
}
</script>